<template>
  <div>     
    <h4>
      {{ getSetText(match.config.type) }}
      {{ index + 1 }}
    </h4>   
    <!--
    <p>{{ graph1 }}</p>
    <p>match:[{{ match }}]</p>
    <p>{{ results }}</p>
    -->
    <div>
      {{ match.localTeam }} 
      [{{ match.sets[index].l }} - {{ match.sets[index].v }}] 
      {{ match.visitorTeam }}
      <!--
      <template v-if="match.config.type==='timeBase'">
        [{{ timeValue }}]
      </template>
      -->
    </div>     
    <LineChart 
      :chart-data="graph1"
      :options="options"
      :height="height" />
  </div>
</template>

<script>
import DateHelper from '@/lib/DateHelper'
import LineChart from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/MatchCharts/LineChart'
const debug = require('debug')('OD::SetChart')

export default {
  name: 'SetChart',
  components: { LineChart },
  props: {
    index: {
      type: Number,
      required: true,
    },
    set: {
      type: Object,
      required: true,
    },
    match: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      timer: null,
      timeValue: '00:00',
      height: 200,
      graph1: {},
      results: [],
      options: {
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              ticks: {
                autoSkip: true,
                maxTicksLimit: 10,
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            title: (tooltipItem, data) => {
              return `${this.match.localTeam} vs ${this.match.visitorTeam}`
            },
            label: (tooltipItem, data) => {
              const index = tooltipItem.index
              if (index >= 0) {
                return `${this.$t('page.match.result')}: ${this.results[index]}`
              }
              return ''
            },
            afterLabel: (tooltipItem, data) => {
              let index = tooltipItem.index - 1
              if (this.match.config.type === 'timeBase') {
                index += 1
              }
              const textArray = []
              if (index >= 0) {
                const event = this.events[index]
                if (event.team) {
                  const diff = tooltipItem.yLabel
                  if (diff !== 0) {
                    const team = diff > 0 ? this.match.localTeam : this.match.visitorTeam
                    textArray.push(`${team}: +${Math.abs(tooltipItem.yLabel)}`)
                  }
                }
                if (event.player) {
                  const team = event.team === 'l' ? this.match.localTeam : this.match.visitorTeam
                  const name = event.player.name
                    ? `#${event.player.num} - ${event.player}`
                    : `#${event.player.num}`
                  textArray.push(`${this.$t('general.player')}: ${name} [ ${team} ]`)
                }
                if (event.code) {
                  debug('YYY', event.code, event.extraPlayer)
                  if (event.code.indexOf('change') >= 0 && event.extraPlayer) {
                    textArray.push(
                      `${this.$t('general.action')}: ${this.$t(
                        `sport.controls.${event.code}.description`
                      )} #${event.player.num} > #${event.extraPlayer.num}`
                    )
                  } else {
                    textArray.push(
                      `${this.$t('general.action')}: ${this.$t(
                        `sport.controls.${event.code}.description`
                      )}`
                    )
                  }
                }
              }
              return textArray
            },
          },
          displayColors: false,
        },
      },
    }
  },
  computed: {
    getOnlyPointEvents() {
      if (this.events) {
        return this.events.filter(event => event.action === 'point')
      }
      return []
    },
    events() {
      let events = this.set.events
      events = events.filter(event => {
        if (!event.hide) {
          return event
        }
      })
      return events
    },
  },
  watch: {
    set() {
      debug('WATCH set')
      this.calculateCharts()
      // this.checkTimer()
    },
    /*
    match() {
      debug('WATCH match')
      this.calculateCharts()
      this.checkTimer()
    },
    */
  },
  created() {
    this.calculateCharts()
    // this.startTimer()
  },
  beforeDestroy() {
    debug('beforeDestroy')
    // this.stopTimer()
  },
  methods: {
    checkTimer() {
      if (this.match.config.type === 'timeBase') {
        if (this.events) {
          debug('checkTimer', {
            a: this.events[this.events.length - 1].action,
            t: this.timer,
          })
          if (this.timer === null) {
            if (this.events[this.events.length - 1].action !== 'stop') {
              this.startTimer()
            }
          }
        }
      }
    },
    startTimer() {
      if (this.match.config.type === 'timeBase' && this.events && this.events.length > 0) {
        debug('startTimer')
        this.timer = setInterval(() => {
          debug('updating ticker', this)
          const ini = this.events[0].when
          let last = null
          if (this.events && this.events[this.events.length - 1].action === 'stop') {
            last = this.events[this.events.length - 1].when
            this.stopTimer()
          }
          this.timeValue = DateHelper.getDatesDiffString(ini, last)
        }, 1000)
      }
    },
    stopTimer() {
      if (this.match.config.type === 'timeBase') {
        debug('stopTimer')
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }
    },
    calculateCharts() {
      const graph = {
        labels: [],
        datasets: [
          {
            label: `Resultado`,
            showXLabels: 10,
            fill: true,
            backgroundColor: 'rgba(149,190,212,0.1)',
            borderColor: 'rgba(149,190,212,0.5)',
            hitRadius: 2,
            data: [],
          },
        ],
      }
      switch (this.match.config.type) {
        case 'pointBase':
          this.calculateChartsPoints(graph, this.events)
          break
        case 'timeBase':
          this.calculateChartsTime(graph, this.events)
          break
        case 'baseballBase':
          this.calculateChartsBaseBall(graph, this.events)
          break
      }
    },
    calculateChartsPoints(graph, events) {
      const y = []
      this.results = []
      this.pointBackgroundColor = []
      this.pointStyle = []
      this.radius = []
      let resultA = 0
      let resultB = 0
      if (events && events.length > 0) {
        y.push(0)
        this.results.push('0-0')
        this.pointBackgroundColor.push('white')
        this.pointStyle.push('circle')
        this.radius.push(3)

        events.forEach(event => {
          // Points
          if (event.num > 0) {
            let teamAux = event.team
            if (event.opposite) {
              teamAux = teamAux === 'l' ? 'v' : 'l'
            }
            if (teamAux === 'l') {
              resultA += event.num || 1
            } else {
              resultB += event.num || 1
            }
            this.pointStyle.push('circle')
            this.radius.push(3)
          } else {
            const style = event.team === 'l' ? 'triangle' : 'rectRot'
            this.pointStyle.push(style)
            this.radius.push(5)
          }
          /*
          'cross' 'crossRot' 'dash' 'line' 'rect' 'rectRounded' 'rectRot' 'star' 'triangle'
          */

          y.push(resultA - resultB)
          this.results.push(`${resultA}-${resultB}`)
          this.pointBackgroundColor.push(event.color)
        })
      }
      graph.labels = this.results
      graph.datasets[0].data = y
      graph.datasets[0].pointBackgroundColor = this.pointBackgroundColor
      graph.datasets[0].radius = this.radius
      graph.datasets[0].pointStyle = this.pointStyle
      debug('graph', graph)
      this.graph1 = graph
    },
    calculateChartsTime(graph, events) {
      const y = []
      this.results = []
      this.pointBackgroundColor = []
      this.pointStyle = []
      this.radius = []
      let resultA = 0
      let resultB = 0
      if (events && events.length > 0) {
        // let start = null
        if (events) {
          /*
          if (events.length > 0) {
            start = events[0].when
          }
          */

          for (let index = 0; index < this.index; index++) {
            resultA += this.match.sets[index].l
            resultB += this.match.sets[index].v
          }

          events.forEach(event => {
            // Points
            if (event.num > 0) {
              let team = event.team
              if (event.opposite) {
                team = team === 'l' ? 'v' : 'l'
              }
              if (team === 'l') {
                resultA += event.num || 1
              } else {
                resultB += event.num || 1
              }
              this.pointStyle.push('circle')
              this.radius.push(3)
            } else {
              const style = event.team === 'l' ? 'triangle' : 'rectRot'
              this.pointStyle.push(style)
              this.radius.push(5)
            }

            // const x = DateHelper.getDatesDiffString(start, event.when)
            y.push(resultA - resultB)
            // this.results.push(`${resultA}-${resultB} [ ${x} ]`) // No time
            this.results.push(`${resultA}-${resultB}`)
            this.pointBackgroundColor.push(event.color)
          })
        }
      }
      graph.labels = this.results
      graph.datasets[0].data = y
      graph.datasets[0].pointBackgroundColor = this.pointBackgroundColor
      graph.datasets[0].pointStyle = this.pointStyle
      graph.datasets[0].radius = this.radius
      this.graph1 = graph
    },
    calculateChartsBaseBall(graph, events) {
      const y = []
      this.results = []
      this.pointBackgroundColor = []
      this.pointStyle = []
      this.radius = []
      let resultA = 0
      let resultB = 0
      if (events && events.length > 0) {
        y.push(0)
        this.results.push('0-0')
        this.pointBackgroundColor.push('white')
        this.pointStyle.push('circle')
        this.radius.push(3)

        events.forEach(event => {
          // Points
          if (event.num > 0) {
            let teamAux = event.team
            if (event.opposite) {
              teamAux = teamAux === 'l' ? 'v' : 'l'
            }
            if (teamAux === 'l') {
              resultA += event.num || 1
            } else {
              resultB += event.num || 1
            }
            this.pointStyle.push('circle')
            this.radius.push(3)
          } else {
            const style = event.team === 'l' ? 'triangle' : 'rectRot'
            this.pointStyle.push(style)
            this.radius.push(5)
          }
          /*
          'cross' 'crossRot' 'dash' 'line' 'rect' 'rectRounded' 'rectRot' 'star' 'triangle'
          */

          y.push(resultA - resultB)
          this.results.push(`${resultA}-${resultB}`)
          this.pointBackgroundColor.push(event.color)
        })
      }
      graph.labels = this.results
      graph.datasets[0].data = y
      graph.datasets[0].pointBackgroundColor = this.pointBackgroundColor
      graph.datasets[0].radius = this.radius
      graph.datasets[0].pointStyle = this.pointStyle
      debug('graph', graph)
      this.graph1 = graph
    },
    getSetText(type) {
      switch (type) {
        case 'pointBase':
          return this.$t('page.match.set')
        case 'timeBase':
          return this.$t('page.match.period')
        case 'baseballBase':
          return this.$t('page.match.inning')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chart {
  border: 1px solid #ddd;
}
</style>
